import { paths } from '../routes/paths';

const PREFIX = `${paths.app}/`;

/**
 * Map current pathname to backend page_id for Evolution AI context.
 */
export function resolvePageId(pathname = '') {
  const path = pathname.replace(/\/+$/, '') || paths.app;

  if (path === paths.app || path === paths.dashboard) return 'dashboard';
  if (path.startsWith(paths.budget)) return 'budget';
  if (path.startsWith(paths.expenses)) return 'expenses';
  if (path.startsWith(paths.categories)) return 'categories';
  if (path.startsWith(paths.goals)) return 'goals';
  if (path.startsWith(paths.income)) return 'income';
  if (path.startsWith(paths.dividas)) return 'dividas';
  if (path.startsWith(paths.pots)) return 'pots';
  if (path.startsWith(paths.emergencyFund)) return 'emergency_fund';
  if (path.startsWith(paths.ativos)) return 'accounts';
  if (path.startsWith(paths.patrimonio)) return 'patrimonio';
  if (path.includes('/selfie/result/') && path.endsWith('/report')) return 'selfie_report';

  if (path.startsWith(PREFIX)) {
    const tail = path.slice(PREFIX.length).split('/')[0];
    if (tail === 'dividas') return 'dividas';
  }

  return 'default';
}
